const swiperMerch = new Swiper('.swiper-merch', { // Optional parameters
  slidesPerView: 'auto',

// If we need pagination
  pagination: {
    el: '.swiper-pagination'
  },

// Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});